import React, { memo } from 'react';
import { Stack, Typography, Card } from 'investira.react.components';
import InlineGauge from '../_components/InlineGauge';

const AvaliacoesOutputHighlights = memo(props => {
  const { nota = 0, nota_quantitativa = 0, nota_qualitativa = 0 } = props;

  const colorNota = (pNota = 0) => {
    return pNota < 1.8
      ? 'error.contrastText'
      : pNota < 2.2
      ? 'warning.contrastText'
      : pNota < 3
      ? 'info.contrastText'
      : 'primary.contrastText';
  };

  const bgcolorNota = (pNota = 0) => {
    return pNota < 1.8
      ? 'error.main'
      : pNota < 2.2
      ? 'warning.main'
      : pNota < 3
      ? 'info.main'
      : 'primary.main';
  };

  const formatNota = pNota => {
    return Number.isInteger(pNota) ? `${pNota}.0` : pNota;
  };

  return (
    <Stack direction="column" sx={{ gap: 1, minWidth: '320px' }} component="section">
      <Stack gap={1} flexGrow={1} direction="column">
        <Card
          sx={{
            display: 'flex',
            flex: 1,
            backgroundColor: bgcolorNota(nota)
          }}>
          <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
            <Typography variant="caption" color={colorNota(nota)} sx={{ fontWeight: 500 }}>
              Nota geral
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack>
                <Typography variant="h2" color={colorNota(nota)} sx={{ fontWeight: 600 }}>
                  {formatNota(nota)}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="caption" color={colorNota(nota)} sx={{ fontWeight: 500 }}>
                  Aprovado / Em conformidade
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>

        <Stack gap={1} direction="row">
          <Stack gap={1} flexGrow={1}>
            <Card
              sx={{
                display: 'flex',
                flex: 1,
                backgroundColor: bgcolorNota(nota_qualitativa)
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography
                  variant="caption"
                  color={colorNota(nota_qualitativa)}
                  sx={{ fontWeight: 500 }}>
                  Nota qualitativa
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography
                      variant="h6"
                      color={colorNota(nota_qualitativa)}
                      sx={{ fontWeight: 600 }}>
                      {formatNota(nota_qualitativa)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} flexGrow={1}>
            <Card
              sx={{
                display: 'flex',
                flex: 1,
                backgroundColor: bgcolorNota(nota_quantitativa)
              }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography
                  variant="caption"
                  color={colorNota(nota_quantitativa)}
                  sx={{ fontWeight: 500 }}>
                  Nota quantitativa
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography
                      variant="h6"
                      color={colorNota(nota_quantitativa)}
                      sx={{ fontWeight: 600 }}>
                      {formatNota(nota_quantitativa)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
        <Stack gap={1} direction="row">
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <InlineGauge
                label="Escala da nota geral"
                value={nota}
                min={0}
                max={3}
                ticks={[0, 1, 2, 3]}
                ranges={[
                  { from: 0, to: 1.2, color: 'error.main' },
                  { from: 1.2, to: 2.25, color: 'warning.main' },
                  { from: 2.25, to: 3, color: 'success.main' }
                ]}
              />
            </Stack>
          </Card>
        </Stack>

        <Stack gap={1} direction="row">
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Próxima avaliação
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    Fevereiro 2027
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>

      <Stack gap={1} direction="row">
        <Stack gap={1} flexGrow={1}>
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Justificativas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    10
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flexGrow={1}>
          <Card
            sx={{
              display: 'flex',
              flex: 1
            }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                Notas alteradas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
                    4
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default AvaliacoesOutputHighlights;
